import * as React from 'react';

import type { HiveWorkingBranch, HiveWorkingDocument } from '@gitbook/hive-client';

/**
 * Hook to subscribe to the read-only property of a Hive document or revision.
 */
export function useHiveReadOnly(model: HiveWorkingDocument | HiveWorkingBranch): boolean {
    const listeners = React.useMemo(() => {
        return {
            subscribe: (callback: () => void) =>
                model.dataSync.listen('readOnly', () => callback()),
            getSnapshot: () => model.dataSync.readOnly,
        };
    }, [model]);

    const value = React.useSyncExternalStore(listeners.subscribe, listeners.getSnapshot);

    return value;
}
